// extracted by mini-css-extract-plugin
module.exports = {"pageError":"lot-page-error_pageError__JInJj"};